export default __webpack_public_path__ + "word_outlaw.d694ee.svg";